import templateUrl from '../../../../common/ui/corpSiteSignupLink/corpSiteSignupLink.tpl.html';

export default { templateUrl };
